import moment from "moment";

class Controller {
  constructor($mdDialog, Ride, Captain, Events, RidesTransforms, captainId) {
    "ngInject";

    this.Ride = Ride;
    this.Events = Events;
    this.Captain = Captain;
    this.captainId = captainId;
    this.$mdDialog = $mdDialog;
    this.RidesTransforms = RidesTransforms;
    this.errorEvent = this.Events.eventsType.onShowErrorNotification;
  }

  close() {
    this.$mdDialog.cancel();
  }

  getCaptainRides(params) {
    params = Object.assign({}, params, {
      status: "scheduled",
      captain: this.captainId,
    });

    this.Ride.getAll(params).$promise.then(
      (response) => {
        this.captainRides = this.RidesTransforms.justify(response.hits);
        this.showLoader = false;
      },
      (response) => this.Events.emit(this.errorEvent, response.data)
    );
  }

  confirm() {
    this.postingVacation = true;
    this.showLoader = true;
    const params = {};
    const showNotificationEvent = this.Events.eventsType
      .onShowSuccessNotification;
    const startDate = this.startDate;
    const endDate = this.endDate;
    const comment = this.comment;
    if (startDate && endDate) {
      params.start_date = moment(startDate).startOf("day").toDate();
      params.end_date = moment(endDate).endOf("day").toDate();
    } else if (startDate && !endDate) {
      params.date = moment(startDate).startOf("day").toDate();
    }
    params.comment = comment;

    this.Captain.updateAction(
      this.captainId,
      "add_vacation",
      params
    ).$promise.then(
      () => {
        this.Events.emit(showNotificationEvent, {
          message: "Captain vacation added successfully.",
        });
        this.getCaptainRides(params);
      },
      (response) => {
        this.postingVacation = false;
        this.showLoader = false;
        this.Events.emit(this.errorEvent, response.data);
      }
    );
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/captain/vacationDialog/vacationDialog.controller.js